module.exports = __webpack_public_path__ + "static/media/04.ab644693.mp3";